import { Component, ViewChild, Input, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {DataSourceGrid} from '../../utils/data-source-grid.component';
import { MatPaginator,MatDialog, MatSort, MatTabChangeEvent, MatSortModule } from '@angular/material';
import { modalConfirmationComponent } from '../../utils/modal/modal-confirmation.component';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
import { Cliente } from '../../models/cliente';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { SaleExportData, SaleDetails } from '../../models/sale-export-data';
// import { PdfExporterService } from '../service/pdf-exporter.service';
import { PdfExporterService } from '../../venta/service/pdf-exporter.service';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { PagoVentaService } from '../../pago-venta/pago-venta.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

import * as moment from 'moment';
import 'moment/locale/es';
import { utils } from '../../utils/utils';

import { modalChangeToCashOutComponent } from './cahngeToCashOut/changeToCashOut.component';
import { DataService } from '../../utils/data.service';
import { Params } from '@angular/router';
import { modalComponent } from '../../utils/modal/modal.component';

@Component({
    selector: 'my-historial-pagos',
    styleUrls: ['./historial-pagos.component.scss'], 
    templateUrl: 'historial-pagos.component.html',
    providers: [generalService, PdfExporterService]
})

export class HistorialPagosComponent {
  public datosGeneralesSAE: any;
  dataCobrar: DataSourceGrid | null;
  dataVentas: DataSourceGrid | null;
  dataAprobacion: DataSourceGrid | null;
  displayedColumns = ['columnaUno', 'columnaOpciones', 'columnaDos', 'columnaTres', 'columnaCuatro', 'columnaCinco', 'columnaSeis'];
  displayedColumnsII = ['columna','columnaI', 'columnaII', 'columnaIII', 'columnaIV', 'columnaV'];
  displayedColumnsIII = ['columnaOne', 'columnaTwo', 'columnaThree', 'columnaFour', 'columnaFive', 'columnaSix'];
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea cancelar el pago?';
  @Input() cliente: Cliente;
  public cliente_id: string;
  public cliente_type: string;
  public historialDeudas:Array<any>;
  public historialVentas:Array<any>;
  public historialAprobacion:Array<any>;
  public detallesAprobacion:Array<any>;
  public string: string;
  public stringVentas: string;
  public stringAprobacion: string;
  public stringDetalles: string;
  public cuentasCobrar: boolean = true;
  public ventas: boolean = false;
  public aprobacionPagos: boolean = false;
  public matOptions: any;
  public selectedOption: any;
  public selectedSale: any;
  public selectedPayment: any;
  public rowAEliminar: any;
  public filtros: any;
  public showDatepicker: boolean = false;
  public filtrosVentas: any = 0;
  public filtrosAprobacion: any = 0;
  public ventaFiltro: any;
  public pagoFiltro: any = 0;
  private cuentasAPagar = [];
  public arrayPagos = [];
  public admin: boolean = false;
  public noAdmin: boolean = false;
  public changePayment: boolean;
  public disablePayment: boolean = false;
  public filtroHistorial: number = 0;

  //NUEVAS VARIABLES 
  public mostrarVentas: boolean = false;
  public mostrarCuentas: boolean = false;
  public mostrarPagos: boolean = false;

  public CANT_DOCUMENTS: string;
  public TOTAL: string;
  public TOTALNumber: number;
  public documentExport: any;
  public _utils: utils;

  public idVenta: number;
  public VentaCompra: string;
  public VentaCompra2: string;
  public banderaVenta:boolean
  public banderaCompra:boolean
  public clienteProveedor: string;
  public parametroUrl:any;

  @ViewChild('tableVenta') tableVenta: ElementRef;


  locale: {
    language: 'es',
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    applyLabel: 'Ok',
    customRangeLabel: 'Rango Personalizado',
    firstDay: 1   };
  ranges: any = {
    'Hoy': [moment(), moment()],
    'Semana actual': [moment().startOf('week'), moment().endOf('week')],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()] };

  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment(), 
  };

constructor( private formBuilder: FormBuilder, private router: Router, 
             public dialog: MatDialog, private pdfExporterService: PdfExporterService, 
             private route: ActivatedRoute, private _generalService: generalService,

             public dataService: DataService,

             private pagoVentaService: PagoVentaService,public _activated : ActivatedRoute) {
  this.idVenta = this.dataService.id;
  this._utils = new utils();
  let auxArray: any = this.route.snapshot.paramMap.get('id').split(':');
  this.cliente_id = auxArray[0].trim(); // ID
  this.cliente_type = auxArray[1].trim(); // TYPE
  this.cliente = new Cliente();
  this.historialDeudas = new Array();
  this.historialVentas = new Array();
  this.historialAprobacion = new Array();
  this.datosGeneralesSAE = DatosGeneralesSAE;
  this.datosGeneralesSAE.showSpinnerLoading = true;
  moment.locale('es');
  this._activated.params.forEach((params: Params)=>{
    this.parametroUrl = params['parametro'];
    console.log(this.parametroUrl);
  });
}

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sortII: MatSort;
  @ViewChild('paginatorII') paginatorII: MatPaginator;
  @ViewChild(MatSort) sortIII: MatSort;
  @ViewChild('paginatorIII') paginatorIII: MatPaginator;

  private saleExportName = 'Exportacion Individual';
  public saleExportData: SaleExportData = new SaleExportData();
  public nota: string = 'Nota: Los precios pueden variar al momento de la venta';

  @ViewChild('pdfContainer')
  private pdfContainer: ElementRef;

  @ViewChild('pdfContainerNoPrice')
  private pdfContainerNoPrice: ElementRef;

	ngOnInit() {    
    this.getCliente(this.cliente_id);
    this.isAdmin();
    this.consultarHistorial(this.filtroHistorial);
    //this.consultarVentas(this.ventaFiltro);
    //this.consultarAprobacion(this.pagoFiltro);
    //this.consultarAprobacionDetalles();
    this.buildMatOptionsList();
    this.validarclienteProveedor();
  }

  ngModelChange(valor){
    this.datosGeneralesSAE.showSpinnerLoading = true;
    if(this.cuentasCobrar === true) {
      this.consultarHistorial(this.filtroHistorial); }
    if(this.ventas === true) {
      this.consultarVentas(this.ventaFiltro);  }
    if(this.aprobacionPagos === true){
      this.consultarAprobacion(this.pagoFiltro); }
  }

  isAdmin(){
    if (this.userData.ADMIN == 1) {
      this.admin = true;  }
    else {
      this.noAdmin = true;  }
  }
    
  getCliente(id:any){
    this._generalService.metodoCall(`cliente/consultarCliente/${id}`).subscribe(
      result => {
        let res = JSON.parse(result);
        this.cliente = res[0];

        if (res[0].DEBT === 0) {
          this.disablePayment = true; }else{this.disablePayment = false;}
      },
      error => {
        console.log(<any>error);  }
    );
  }

  //Tab de Cuentas por cobrar
  consultarHistorial(filtro: number){
    this.filtroHistorial = filtro;
    if (filtro == 0){
      this.showDatepicker = false;
      //document.getElementById("idDatePicker").style.visibility = "hidden";
      this.string = "HistorialPagos/consultarHistorialTodos/" + this.cliente_id; 
      this._generalService.metodoCall(this.string).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.historialDeudas = tableResult.Table;
          this.dataCobrar = new DataSourceGrid(this.historialDeudas, this.paginator, this.sort);
          if(this.historialDeudas.length <= 0)
          { 
            $(".mat-row").remove(".mat-row");
            this.mostrarCuentas = false;
            this.CANT_DOCUMENTS = undefined;
            this.TOTAL = undefined;
            this.TOTALNumber = 0;
          } else {
            this.mostrarCuentas = true;
            this.CANT_DOCUMENTS = tableResult.Table1[0].CANT_DOCUMENTS;
            this.TOTAL = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(tableResult.Table1[0].TOTAL);
            this.TOTALNumber = tableResult.Table1[0].TOTAL;
          }
            //{ $(".mat-row").remove(".mat-row"); }
            this.datosGeneralesSAE.showSpinnerLoading = false;
          },
        error => {  console.log(<any>error);  }
      );
    }
    if (filtro == 1){
      let tipo = 'agregar';
      this.string = "HistorialPagos/consultarHistorialActuales/";
      this.filtros = {
        rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
        rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD'),
        idCliente: this.cliente_id
      };
      this.showDatepicker = true;
      //document.getElementById("idDatePicker").style.visibility = "visible";
      this._generalService.metodoCallParamsPutPost(tipo, this.filtros, this.string).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.historialDeudas = tableResult.Table;
          this.dataCobrar = new DataSourceGrid(this.historialDeudas, this.paginator, this.sort);
          if(this.historialDeudas.length <= 0)
          { 
            $(".mat-row").remove(".mat-row");
            this.mostrarCuentas = false;
            this.CANT_DOCUMENTS = undefined;
            this.TOTAL = undefined;
            this.TOTALNumber = 0;
          } else {
            this.mostrarCuentas = true;
            this.CANT_DOCUMENTS = tableResult.Table1[0].CANT_DOCUMENTS;
            this.TOTAL = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(tableResult.Table1[0].TOTAL);
            this.TOTALNumber = tableResult.Table1[0].TOTAL;
          }
            //{ $(".mat-row").remove(".mat-row"); }
            this.datosGeneralesSAE.showSpinnerLoading = false;
          },
        error => {  console.log(<any>error);  }
      ); 
    }
    if (filtro == 2){
      this.showDatepicker = false;
      //document.getElementById("idDatePicker").style.visibility = "hidden";
      this.string = "HistorialPagos/consultarHistorialVencidas/" + this.cliente_id; 
      this._generalService.metodoCall(this.string).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.historialDeudas = tableResult.Table;
          this.dataCobrar = new DataSourceGrid(this.historialDeudas, this.paginator, this.sort);
          if(this.historialDeudas.length <= 0)
          { 
            $(".mat-row").remove(".mat-row");
            this.mostrarCuentas = false;
            this.CANT_DOCUMENTS = undefined;
            this.TOTAL = undefined;
            this.TOTALNumber = 0;
          } else {
            this.mostrarCuentas = true;
            this.CANT_DOCUMENTS = tableResult.Table1[0].CANT_DOCUMENTS;
            this.TOTAL = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(tableResult.Table1[0].TOTAL);
            this.TOTALNumber = tableResult.Table1[0].TOTAL;
          }
            //{ $(".mat-row").remove(".mat-row"); }
            this.datosGeneralesSAE.showSpinnerLoading = false;
          },
        error => {  console.log(<any>error);  }
      );}
  }

  consultarVentas(filtro:number){
    this.ventaFiltro = filtro;
    let tipo = 'agregar';
    this.stringVentas = "HistorialPagos/consultarVentasHistorial/";
    this.filtrosVentas = {
      idCliente: this.cliente_id,
      idTipo: filtro, 
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD'),
    };

    this._generalService.metodoCallParamsPutPost(tipo, this.filtrosVentas, this.stringVentas).subscribe(
      result => {
        this.historialVentas = JSON.parse(result);
        this.dataVentas = new DataSourceGrid(this.historialVentas, this.paginatorIII, this.sortIII);
        if(this.historialVentas.length <= 0)
          { 
            $(".mat-row").remove(".mat-row");
            this.mostrarVentas = false;
          } else {
            this.mostrarVentas = true;
          }
        this.datosGeneralesSAE.showSpinnerLoading = false;
        },
      error => {  console.log(<any>error);  }
    );
  }

//Tab de Pagos
  consultarAprobacion(opcion){
    this.pagoFiltro = opcion;
    let tipo = 'agregar';
    this.stringAprobacion = "HistorialPagos/consultarAprobacionPagos/";
    this.filtrosAprobacion = {
      idCliente: this.cliente_id,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD'),
      filtro: opcion  };

    if (this.pagoFiltro == 0) {
      this.changePayment = true;  }
    else {
      this.changePayment = false; }

    //console.log(this.filtrosAprobacion);

    this._generalService.metodoCallParamsPutPost(tipo, this.filtrosAprobacion, this.stringAprobacion)
      .subscribe(result => {
        this.historialAprobacion = JSON.parse(result);
        this.dataAprobacion = new DataSourceGrid(this.historialAprobacion, this.paginatorII, this.sortII);
        if(this.historialAprobacion.length <= 0)
        { 
          $(".mat-row").remove(".mat-row");
          this.mostrarPagos = false;
          this.datosGeneralesSAE.showSpinnerLoading = false;
        } else {
          //this.consultarAprobacionDetalles();
          this.mostrarPagos = true;
        }
        //  { $(".mat-row").remove(".mat-row"); }
        this.datosGeneralesSAE.showSpinnerLoading = false;
        },
      error => {  console.log(<any>error);  }
    ); 
  }


//Tab de Pagos
  consultarAprobacionDetalles(){
    this.stringDetalles = "HistorialPagos/consultarAprobacionDetalles/" + this.cliente_id;
    this._generalService.metodoCall(this.stringDetalles).subscribe(
      result => { 
        this.detallesAprobacion = JSON.parse(result);
        this.datosGeneralesSAE.showSpinnerLoading = false;  },
      error => {  console.log(<any>error);  }
    );
  }

  back()  {
      this.router.navigate(['../../clientes-sae'],{ relativeTo: this.route });    
  }

  tabChange (event: MatTabChangeEvent) {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    const tabName = event.tab.textLabel;
    //this.dateRange.startDate = moment().startOf('month');
    //this.dateRange.endDate = moment();
    if (tabName === "Cuentas por Cobrar"){
        this.cuentasCobrar = true;
        this.ventas = false;
        this.aprobacionPagos = false;
        if (this.filtroHistorial === 1) {
          this.showDatepicker = true;
        } else {
          this.showDatepicker = false;
        }
        this.consultarHistorial(this.filtroHistorial);
    }

    if (tabName === "Ventas"){
        this.cuentasCobrar = false;
        this.ventas = true;
        this.aprobacionPagos = false;
        this.showDatepicker = true;
        this.consultarVentas(this.ventaFiltro);
    }
    if (tabName === "Compras"){
      this.cuentasCobrar = false;
      this.ventas = true;
      this.aprobacionPagos = false;
      this.showDatepicker = true;
      this.consultarVentas(this.ventaFiltro);
  }

    if (tabName === "Pagos"){
        this.cuentasCobrar = false;
        this.ventas = false;
        this.aprobacionPagos = true;
        this.showDatepicker = true;
        this.consultarAprobacion(this.pagoFiltro);
        this.consultarAprobacionDetalles();
    }
  }

  buildMatOptionsList() {
    this.matOptions = new Object();
    this.matOptions.show = [
      {code: 0 , meaning: 'Todas'},
      {code: 1 , meaning: 'No Vencidas'},
      {code: 2 , meaning: 'Vencidas'},
    ];

    this.matOptions.sales = [
      {code: 0 , meaning: 'Todas'},
      {code: 1 , meaning: 'Venta Directa'},
      {code: 2 , meaning: 'Venta Pedido'},
    ];

    this.matOptions.payments = [
      {code: 0 , meaning: 'Sin aprobar'},
      {code: 1 , meaning: 'Aprobadas'},
      {code: 2 , meaning: 'Rechazadas'},
    ];
    this.selectedOption = this.matOptions.show[0].code;
    this.selectedSale = this.matOptions.sales[0].code;
    this.selectedPayment = this.matOptions.payments[0].code;
  }

  // -------------- FUNCIONES DE ACCIONES ---------------
  editarCuentasPorPagar(cuentaAgregada: boolean, cuentaAPagar) {
    if (cuentaAgregada) {
      this.cuentasAPagar.push(cuentaAPagar);
    } else {
      // this.cuentasAPagar = this.cuentasAPagar.filter((cuenta) => cuenta.idVenta !== cuentaAPagar.idVenta);
      this.cuentasAPagar = this.cuentasAPagar.filter((cuenta) => cuenta.DOCUMENT_ID  !== cuentaAPagar.DOCUMENT_ID );
    }
    //console.log(this.cuentasAPagar);
  }
  
  pagarVentas() {
    if(this.cliente.DEBT == this.TOTALNumber)
    {
      this.pagoVentaService.pagarVentas(this.cuentasAPagar, this.cliente);
    }
    else
    {
      this._generalService.toastCall("La deuda del Cliente no coincide con la sumatoria de deudas de Ventas, favor de comunicarse con el administrador del sistema.");
    }
  }

  editarArrayPagos(pagoAgregado: boolean, pagoAgregar) {
    if(pagoAgregado){
      this.arrayPagos.push(pagoAgregar);  }
    else {
      this.arrayPagos.forEach( 
        (item, index) => {
          if(item === pagoAgregar) this.arrayPagos.splice(index,1); });
    }
  }

  aprobarPagos(isApproved){
    let tipo = 'agregar';

    if(this.arrayPagos.length >= 1){
      //for (let i = 0; i < this.arrayPagos.length; i++) {
        let datosPago ={
          //idPago: this.arrayPagos[i],
          aprobacion: isApproved,
          idUsuario: this.userData.USER_ID,
          json: JSON.stringify(this.arrayPagos)
        };
        
        let link = 'HistorialPagos/actualizarPagos/';
        this._generalService.metodoCallParamsPutPost(tipo, datosPago, link)
          .subscribe( (result) => {
            const arrayResult = JSON.parse(result);
            for (let i = 0; i < arrayResult.length; i++) {
              if (arrayResult[i] != '') {
                this._generalService.toastCall(arrayResult[i]); } 
              else {
                this._generalService.toastCall("Pago(s) actualizados exitósamente."); this.consultarAprobacion(0); this.consultarVentas(0);}
            }
          },
          (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj); 
          }); 
        console.log(datosPago);  
      //}
    }
    else{
      this._generalService.toastCall("No se ha seleccionado un pago para realizar esta acción");
    }
  }

  confirmarEliminacionVenta(row: any){
    this.rowAEliminar = row;
    const dialogRef = this.dialog.open(modalConfirmationComponent, {
      disableClose: true, data: {
        mensaje: '¿Desea cancelar la venta: ' + row.numeroVenta + '?',  }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
      if(result == 1){
        //this.reduccionDeuda();
        this.eliminarVenta(); }
    });
  }


  reduccionDeuda(){
    let reduccion = "HistorialPagos/reduccionDeuda/" + this.rowAEliminar.idVenta;
    this._generalService.metodoCall(reduccion).subscribe(
      result => { console.log("Se ha reducido la deuda del cliente");  },
      error => {  console.log(<any>error);  }
    );
  }

  eliminarVenta(){    
    let params: any = {
        USER_ID: this.userData.USER_ID,
        DOCUMENT_TYPE_ID: this.rowAEliminar.idTipoVenta,
        DOCUMENT_ID: this.rowAEliminar.idVenta,
        CLIENT_ID: this.cliente_id
    }

    var paramsJSON: string = JSON.stringify(params);

    this._generalService.requestPut("venta/DeleteDocument?parametros=" + paramsJSON).subscribe(
      result => {
        this.consultarVentas(0); },
      error => {
        var errorMsj = <any>error;
        console.log(errorMsj);
      });
  }

  exportPDF(documentId: any, showPrice:boolean) {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    this._generalService.requestGet("venta/getSaleExportData?documentId=" + documentId).subscribe(
      (saleExporDataSet) => {
        saleExporDataSet = JSON.parse(saleExporDataSet);
        this.saleExportData = this.generateSaleExportDataFromDataSet(saleExporDataSet);
        if(this.saleExportData.saleTypeId === 3){
          this.saleExportData.tipoVenta = "COTIZACIÓN";
          this.saleExportData.note = this.nota;
        }else {
          this.saleExportData.tipoVenta = "VENTA"; }
      setTimeout(() => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
          this.saleExportName = 'Venta ' + this.saleExportData.saleNumber;
          if (showPrice === true){
          // this.pdfExporterService.export(this.pdfContainer, this.saleExportName);
          this.pdfExporterService.export(this.saleExportData, this.saleExportName, showPrice);
          }else{
          // this.pdfExporterService.export(this.pdfContainerNoPrice, this.saleExportName,showPrice);
          this.pdfExporterService.export(this.saleExportData, this.saleExportName, showPrice);
          }
        }, 300);
      }, 
        (error) => {
            console.error(error);
        }
    );
  }

// ---------- FUNCIONES DE EXPORTACIÓN PDF ------------
private generateSaleExportDataFromDataSet(saleExporDataSet): SaleExportData {
    let saleExportData = new SaleExportData();
    
    saleExportData = saleExporDataSet.Table[0];
    saleExportData.details =  saleExporDataSet.Table1;

    var numRenglones = saleExportData.details.length;    

    // const objeto = saleExportData.details[0]

    //     for(let i = 0; i<70; i++){
    //         saleExportData.details.push(objeto);
    //     }

        // if(numRenglones > 17 && numRenglones < 29){
        //     for(var i=numRenglones; i <= 35; i++){
        //         let x = new SaleDetails();
        //         saleExportData.details.push(x);
        //     }
        // }
        // else if(numRenglones >= 29){
        //     for(var i=0; i < 7; i++){
        //         let x = new SaleDetails();
        //         saleExportData.details.splice(28, 0, x);
        //     }
        //     if(numRenglones > 57 && numRenglones < 71){
        //         for(var i=numRenglones; i <= 77; i++){
        //             let x = new SaleDetails();
        //             saleExportData.details.push(x);
        //         }    
        //     }
        //     else if(numRenglones >= 71){
        //         for(var i=0; i < 7; i++){
        //             let x = new SaleDetails();
        //             saleExportData.details.splice(70, 0, x);
        //         }
        //     }
        // }

        saleExportData.hasDiscount = 0;
    return saleExportData;
}

irAPantallaPagos() {
  this.cuentasAPagar = [];
  this.pagoVentaService.pagarVentas(this.cuentasAPagar, this.cliente, true);
}


crearTicketPago(idPayment: any){
  this.datosGeneralesSAE.showSpinnerLoading = true;
  var bandera = false;
  // Se consulta la información y configuración del ticket en base al pago y sucursal
  this._generalService.requestGet("pago/crearTicketPago?idOrganization=" + this.userData.ORGANIZATION_ID + "&idPayment=" + idPayment + "&bandera=" + bandera).subscribe(
      (result) => {

          // El primer paso para imprimir el ticket es transformar la base64 a un arreglo de bytes con el cual se obtendrá un 
          // objeto blob
          const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
              const byteCharacters = atob(b64Data);
              const byteArrays = [];
              for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  const slice = byteCharacters.slice(offset, offset + sliceSize);
                  const byteNumbers = new Array(slice.length);
                  for (let i = 0; i < slice.length; i++) {
                      byteNumbers[i] = slice.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
                  byteArrays.push(byteArray);
              }
              const blob = new Blob(byteArrays, {type: contentType});
              return blob;
          }
          const blob = b64toBlob(result, "application/pdf");

          // Se crea una url valida con el objeto blob
          const blobUrl = URL.createObjectURL(blob);

          // Se elimina el iframe del ticket si ya había sido creado uno
          if (document.getElementById("iframeTicketII") != null){
              $("#iframeTicketII").remove();
          }

          // Se crea un iframe para el ticket y se le pone como src el url creado apartir del blob
          var iframe: any = document.createElement('iframe');
          iframe.id = "iframeTicketII";
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);

          // Se pone en un timeout en lo que se espera a que se agrege al body del document y se pueda imprimir
          setTimeout(()=>{    
              // Se imprime el ticket
              iframe.focus();
              iframe.contentWindow.print();

              this.datosGeneralesSAE.showSpinnerLoading = false;
         }, 100);

      },
      (error) => {
          const errorMsj =  error as any;
          console.error(errorMsj);
      }
  );

}

    exportarExcel () {
        if (this.historialDeudas.length > 0) {
            this.getDocumentsExport();
        }
    }

    getDocumentsExport() {
        this.datosGeneralesSAE.showSpinnerLoading = true;
        this.documentExport = this.historialDeudas;

        setTimeout(() => {
          this.readyExport();
        }, 300);
    }

    readyExport() {
        setTimeout(() => this.exportAsExcelFile('Reporte de Deudas ' + this.cliente.Nombre), 300);
    }

    public exportAsExcelFile(filename: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableVenta.nativeElement);

        const headersWorksheet = ['Núm. Venta', 'Cliente', 'Solicitante', 'Fecha de Venta', 'Estatus', 'Tipo', 'Creado por', 'Fecha de Creación', 'Entrega', 'Dirección', 'Fecha Compromiso Entrega', 'Total $', 'Costo $', 'Utilidad $', 'Utilidad %', 'Observaciones'];
        /*for (const z in worksheet) {
            if (z[0] === '!') { 
                continue; 
            }
            if (worksheet[z]) {                
                if (headersWorksheet.indexOf(worksheet[z].v + '') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'header');
                } else if (z.indexOf('L') > -1 || z.indexOf('M') > -1 || z.indexOf('N') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                } else if (z.indexOf('O') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'porcentaje');
                } else if (((z + '').indexOf('D') > -1 || z.indexOf('H') > -1 || z.indexOf('K') > -1) && worksheet[z].t === 'n' && worksheet[z].z !== 'm/d/yy') {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                }
            }
        }*/

        const workbook: XLSX.WorkBook = { Sheets: { General: worksheet, }, SheetNames: ['General'] };
        const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });

        this.datosGeneralesSAE.showSpinnerLoading = false;
        this.saveAsExcelFile(excelBuffer, filename);
    }

    private wrapAndCenterCell(cell: XLSX.CellObject, tipo: any) {
        let cellStyle;
        switch (tipo) {
            case 'header': {
                cellStyle = { font: {bold: true} };
                break;
            }
            case 'numerico': {
                cellStyle = { numFmt: '0' };
                break;
            }
            case 'decimal': {
                cellStyle = { numFmt: '$0.00;\\($0.00\\);\\-;@' };
                break;
            }
            case 'porcentaje': {
                cellStyle = { numFmt: '0.00%;\\(0.00%\\);\\-;@' };
                break;
            }
        }
        this.setCellStyle(cell, cellStyle);
    }

    private setCellStyle(cell: XLSX.CellObject, style: {}) {

        cell.s = style;
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    cambiarToCashOut(pago: any) {
     const dialogRef = this.dialog.open(modalChangeToCashOutComponent, {
      disableClose: true, 
      width:'40%', 
      maxWidth:'70%', 
      panelClass: 'full-width-dialog',
      data: {
        toCashOut:pago.TO_CASH_OUT,
        idpago:pago.idPago,
      }
    });

    this.dataService.dialogRef = dialogRef;

    dialogRef.afterClosed().subscribe((result) => {
      this.consultarAprobacion(1);
      result == 1? this._generalService.toastCall("Modificación exitosa!") : undefined;
    });

  }

  validarclienteProveedor(){
    if(this.cliente_type == '0'){
      this.VentaCompra = 'Venta'
      this.VentaCompra2 = 'Ventas'
      this.clienteProveedor = 'Cliente'
      this.banderaVenta = true
      this.banderaCompra=false
    }else if(this.cliente_type == '1'){
      this.VentaCompra = 'Compra'
      this.VentaCompra2 = 'Compras'
      this.clienteProveedor = 'Proveedor'
      this.banderaVenta = false
      this.banderaCompra=true
    }
  }

  cancelarPago(idPayment: any){
    //console.log(idPayment);
    
    const params = { 
      loacs: sessionStorage.getItem('acslo'),
      PAYMENT_ID:idPayment
    };
    
    this._generalService.metodoCallParams(params, `HistorialPagos/cancelarPago`).subscribe(
      (result) => {
      const arrayResult = JSON.parse(result);
      if(arrayResult[0].result == 1){
        this.consultarAprobacion(1);
        this.getCliente(this.cliente_id);
        this._generalService.toastCall("El pago ha sido cancelado!")
      }
    },
    (error) => {
      const errorMsj =  error as any;
      console.log(errorMsj); 
    });
    
    
  }

  cancelarPagoConfirmar(idPayment: any) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
  
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;      
    dialogModal.afterClosed().subscribe(result => {
      if (this.dataService.guardado) {
        this.cancelarPago(idPayment);
      }
      
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente-sae/historial-pagos/historial-pagos.component.ts